import { render, staticRenderFns } from "./DtList.vue?vue&type=template&id=1de01b50&scoped=true&"
import script from "./DtList.vue?vue&type=script&lang=js&"
export * from "./DtList.vue?vue&type=script&lang=js&"
import style0 from "./DtList.vue?vue&type=style&index=0&id=1de01b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de01b50",
  null
  
)

export default component.exports